<template>
  <div>
    <b-modal
      :hide-footer="true"
      :centered="true"
      id="modal-schedule-my-student"
      modal-class="modal-schedule"
      size="xl"
      ref="modal_schedule_my_student" 
    >
      <template #modal-header>
        <img
          class="close"
          src="@/assets/img/close_red.png"
          @click="hideModalCalendarStudent"
        />
      </template>
      <div v-if="showLoading" class="container-loading">
        <b-spinner :label="$t('reusables.loading')"></b-spinner>
      </div>
      <div v-else>
        <!-- <b-row>
          <b-col>
            <div Class="card">
              <div class="perfil" style="border-bottom:0px !important;padding-bottom:0px !important;">
            
              <b-avatar 
                          :src="dataStudent.photo ? dataStudent.photo  : urlPhoto " 
                          size="4rem" variant="light"></b-avatar>
                <div class="content">
                  <h6>{{dataStudent.strFullName}}</h6>
                    
                </div>
              </div>
              <div class="form-group">
                <h4>{{$t('modals.modalViewSchedule.text.7')}}</h4>
                <span>
                  <p style="white-space: pre-line;" class="bold">{{dataStudent.strSubjects}}</p>
                </span>
              </div>
            
            </div>
          
          </b-col>
            
          <b-col class="text">
                      <div class="d-flex" v-if="flagProposalEdited">
                          <div style="display: flex;">
                              <b-button variant="outline-primary"  @click="getDetail"  class="btn-outline mr-4 "><b-icon icon="calendar2-week-fill"></b-icon>{{$t('horario.next-class.see-edition')}}</b-button>
                          </div>
                      </div>
          </b-col>
        </b-row> -->
        <div class="card card-img-out">
          <div class="left">
            <img src="@/assets/img/calendar-schedule.png" />
            <h6 class="sub-title text-left">
              <span
                >Schedule</span
              >
            </h6>
          </div>
          <div class="right">
            <span>{{ dataStudent.strFullName }}</span>
          </div>
        </div>
        <div class="container-calendar" style="position: relative">
          <div
            class="body-header edit"
            style="position: absolute; left: 200px; width: 130px"
            v-if="getShowSelect"
          >
            <!-- <b-form-select class="custom-select" v-model="selectedTime" :options="optionsTime" @change="getWeek"></b-form-select> -->
            <CustomSelect
              @input="idValueSelectEventSelectedTime"
              :options="optionsTime"
              value="value"
              label="text"
              :default="null"
              :defaultValue="this.selectedTime"
              :isActiveMethodValidOpcion="true"
              @change="getWeek()"
            />
          </div>
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            :custom-buttons="calendarOptions.customButtons"
            ref="calendarRefs"
          >
            <template v-slot:eventContent="arg">
              <div class="fc-event-main-frame">
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
                <div class="fc-event-time">{{ arg.timeText }}</div>
              </div>
            </template>
          </FullCalendar>
        </div>
      </div>

      <!------------------------modal ----------------------------->
    </b-modal>

    <viewsSheduleTeacher
      ref="modalCalendarTeacherStudent"
      @updateSchedule="handlClaseModalTeacher"
      @list-studensindex="getListStudensIndex" 
    />
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import {
  getCalendarHeaderFormat,
  horarioObtenerColorClaseConsolidado,
  getCalendarTitle,
  getCalendarHeaderToolbar,
  getHoursByTimeZoneName,
  horarioObtenerNameClaseENConsolidado,
  horarioObtenerNameClaseEnEsConsolidado,
  convertToUserTimeCalendarEvents,
  getCalendarEventTimeFormat,
} from "@/assets/js/util.js";
import viewsSheduleTeacher from "@/components/modals/view-schedule-teacher";
let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}
export default {
  name: "viewCalendarStudent",
  components: {
    FullCalendar, // make the <FullCalendar> tag available,
    viewsSheduleTeacher,
    CustomSelect,
  },
  data() {
    return {
      urlPhoto: Constants.IMAGENES.PHOTO_STUDENT_DEFAULT,
      params: null,
      flagShowHeader: true,
      flagProposalEdited: false,
      selectTimeInit: 0,
      formatDay: "DD",
      flagPlanTest: false,
      showSelectWeek: true,
      groupsScheduleProposalEditedId: null,
      lang: localStorage.getItem("lang"),
      message: "",
      uniqDate: [],
      optionsTime: [],
      selectedTime: null,
      showSpinnerAccept: false,
      showSpinnerReject: false,
      dataStudent: {},
      SelectBeginningDate: new Date(),
      scheduleProposalId: false,
      showLoading: false,
      calendarOptions: {
        customButtons: {
          today: {
            text: "Today",
            click: () => {
              this.selectedTime = this.selectTimeInit;
              let calendarApi = this.$refs.calendarRefs.getApi();
              calendarApi.gotoDate(new Date());
            },
          },
          prev: {
            text: "PREV",
            click: () => {
              this.selectedTime--;
              let calendarApi = this.$refs.calendarRefs.getApi();
              calendarApi.prev();
            },
          },
          next: {
            text: "NEXT",
            click: () => {
              this.selectedTime++;
              let calendarApi = this.$refs.calendarRefs.getApi();
              calendarApi.next();
            },
          },
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        events: [],
        firstDay: 1,
        //eventColor: "#4285f4",
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        headerToolbar: getCalendarHeaderToolbar(this.flagShowHeader),
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(
            this.$moment,
            this.$store.state.user.timeZoneName
          );
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = GMT;
        },
        initialView: "timeGridWeek",
        titleFormat: function (date) {
          return getCalendarTitle(date.date, this.lang);
        },
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(
            this.$moment,
            args.date,
            this.lang,
            this.formatDay
          );
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
      },
    };
  },
  computed: {
    getShowSelect() {
      if (this.flagPlanTest) {
        return false;
      } else {
        return this.showSelectWeek;
      }
    },
  },
  methods: {
    getListStudensIndex(){
      this.$emit("list-studens");
    },
    hideModalCalendarStudent() {
      this.$refs["modal_schedule_my_student"].hide();
      this.$emit("list-studens");
    },
    handlClaseModalTeacher() {
      this.getList();
    },
    getDetail() {
      this.$bvModal.show("modal-schedule-teacher");
      this.$refs.modalCalendarTeacherStudent.getShowCalendar(
        this.groupsScheduleProposalEditedId,
        this.dataStudent,
        true
      );
    },
    idValueSelectEventSelectedTime(event) {
      this.selectedTime = event;
    },
    getWeek() {
      let calendarApi = this.$refs.calendarRefs.getApi();
      calendarApi.gotoDate(this.uniqDate[this.selectedTime]);
    },
    getEventIdx: function () {
      let dataTmp = this.calendarOptions.events;
      let idx = 0;

      let ultId =
        dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
      ultId = ultId == null ? 0 : ultId;
      idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

      return idx;
    },

    async getShowCalendar(data) {
      this.flagProposalEdited = false;
      this.params = data;
      await this.getEdit();
      if (this.flagProposalEdited) {
        this.getDetail();
      } else {
        this.params = data;
        this.$bvModal.show("modal-schedule-my-student");
        this.calendarOptions.selectable = false;
        this.getList();
      }
    },

    getList() {
      this.showLoading = true;
      this.calendarOptions.events = [];
      let data = {
        scheduleId: this.params.groupScheduleStudentId,
        groupId: this.params.groupId,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleStudentGroupById`,
          {
            params: data,
          }
        )
        .then((response) => {
          this.showLoading = false;
          this.dataStudent = {
            strFullName: response.data.entity.className,
            photo: response.data.entity.photo,
            strSubjects: this.$store.state.is_teacher
              ? response.data.entity.subjectsName_EN
              : localStorage.getItem("lang") == "es"
              ? response.data.entity.subjectsName
              : response.data.entity.subjectsName_EN,
            beginningDate: null,
          };
          this.flagPlanTest = response.data.entity.flagPlanTest;
          this.flagProposalEdited = response.data.entity.flagProposalEdited;
          this.groupsScheduleProposalEditedId =
            response.data.entity.groupsScheduleProposalEditedId;
          let arrayInitWeek = [];
          let arrayEnabledDate = [];
          let arrayHoursTmp =
            response.data.entity.listGroupScheduleStudentsDetails;
          let arrayHours = convertToUserTimeCalendarEvents(
            arrayHoursTmp,
            this.$store.state.user.timeZoneName,
            this.$moment
          );

          if (response.data.entity.listGroupScheduleStudentsDetails) {
            arrayHours.forEach((element) => {
              //response.data.entity.listGroupScheduleStudentsDetails.forEach(element => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );

              this.calendarOptions.events.push({
                idx: this.getEventIdx(),
                id: createEventId(),
                start: element.startDate,
                description: "",
                end: element.endDate,
                title: this.$store.state.is_teacher
                  ? horarioObtenerNameClaseENConsolidado(
                      element.stateClass.strValue
                    )
                  : horarioObtenerNameClaseEnEsConsolidado(
                      element.stateClass.strValue
                    ),
                editable: false,
                color: horarioObtenerColorClaseConsolidado(
                  element.stateClass.strValue
                ),
              });
            });
          }

          this.flagShowHeader = true;
          if (response.data.entity.flagPlanTest) {
            this.flagShowHeader = false;
          }
          this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
            this.flagShowHeader
          );
          this.optionsTime = [];
          this.uniqDateEnabled = [...new Set(arrayEnabledDate)];

          if (this.uniqDateEnabled.length > 1) {
            this.calendarOptions.validRange = {
              start: this.uniqDateEnabled[0],
              end: this.uniqDateEnabled[this.uniqDateEnabled.length - 1],
            };
          }

          let startOfWeekCurrent = this.$moment().startOf("week").toDate();

          this.uniqDate = [...new Set(arrayInitWeek)];

          let countSelect = 0;
          for (let index = 0; index < this.uniqDate.length; index++) {
            if (
              this.$moment(startOfWeekCurrent).format("YYYY-MM-DD") ==
              this.uniqDate[index]
            ) {
              countSelect = index;
            }
            this.optionsTime.push({
              value: index,
              text: this.$t("reusables.week") + ` ${index + 1}`,
            });
          }

          if (this.uniqDate.length > 0) {
            this.selectedTime = countSelect;
            this.selectTimeInit = countSelect;
          }

          setTimeout(() => {
            if (this.uniqDate.length > 0) {
              let calendarApi = this.$refs.calendarRefs.getApi();
              calendarApi.gotoDate(new Date());
            }
          }, 500);
        });
    },
    async getEdit() {
      this.showLoading = true;
      let data = {
        scheduleId: this.params.groupScheduleStudentId,
        groupId: this.params.groupId,
      };

      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleEditStudentGroupById`,
          {
            params: data,
          }
        )
        .then((response) => {
          this.dataStudent = {
            strFullName: response.data.entity.className,
            photo: response.data.entity.photo,
            strSubjects: this.$store.state.is_teacher
              ? response.data.entity.subjectsName_EN
              : localStorage.getItem("lang") == "es"
              ? response.data.entity.subjectsName
              : response.data.entity.subjectsName_EN,
            beginningDate: null,
          };
          this.flagProposalEdited = response.data.entity.flagProposalEdited;
          this.groupsScheduleProposalEditedId =
            response.data.entity.groupsScheduleProposalEditedId;
        });
    },
  },
};
</script>